/**
 * @generated SignedSource<<88f8f3af2153e61dfa565ff5ba9db3ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestMoreImages_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "RequestMoreImages_item";
};
export type RequestMoreImages_item$key = {
  readonly " $data"?: RequestMoreImages_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestMoreImages_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestMoreImages_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "423eb53f0e393b4adf3acbcf36f0bda7";

export default node;
